module.exports = __webpack_public_path__ + "img/borrador.2a4c72f0.gif";